import { queryOptions } from '@tanstack/react-query';
import { referredFileNumberQueryFunction } from '@/modules/Dashboard/queries/referredFileNumbers/referredFileNumberQueryFunction.ts';

export const referredFileNumberQueryOption = queryOptions({
  queryKey: ['referred_files_count'],
  queryFn: referredFileNumberQueryFunction,
});
